import { render, staticRenderFns } from "./channelDataList.vue?vue&type=template&id=1dec28ab&scoped=true&"
import script from "./channelDataList.vue?vue&type=script&lang=js&"
export * from "./channelDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec28ab",
  null
  
)

export default component.exports